import React, { useState, useEffect } from 'react';
import "./hubspot_support_widget.scss";
import { Button, Modal } from 'react-bootstrap';
import { IoMdHelpCircleOutline } from "react-icons/io";
// import clsx from 'clsx';

const HubspotSupportWidget = ({layout="normal-layout"}) => {

    const [formVisible, setFormVisible] = useState(false);

    // This will hold the script loader status to avoid duplicate script loading
    const [scriptLoaded, setScriptLoaded] = useState(false);

    const createForm = () => {
        if (window.hbspt && document.getElementById("hubspot-form-container")) {
            window.hbspt.forms.create({
                portalId: "45389480",
                formId: "df31736a-e00e-4a2f-8063-c7248d681618",
                region: "na1",
                target: "#hubspot-form-container",
            });
        }
    };

    const loadHubspotScript = () => {
     
        if (!scriptLoaded) {
            const script = document.createElement("script");
            script.src = "https://js.hsforms.net/forms/embed/v2.js";
            script.type = "text/javascript";
            script.async = true;
            script.onload = () => {
                setScriptLoaded(true); // Mark script as loaded
                if (formVisible) {
                    createForm(); // Create form when modal is shown
                }
            };
            document.body.appendChild(script);
        } else if (scriptLoaded) {
            // If script is already loaded and modal is visible, create the form
            if (formVisible) {
                createForm();
            }
        }
    };

    useEffect(() => {
        loadHubspotScript(); // Ensure script is loaded
        // eslint-disable-next-line
    }, [formVisible]); // Trigger loading when formVisible changes

    return (
        <>
            <Button
                className={layout === 'fixed-layout' ? "fixed-layout" : 'normal-layout'}
                onClick={() => setFormVisible(true)} // Show modal when button is clicked
            >
                <IoMdHelpCircleOutline size={25} style={{ marginRight: 5, marginBottom: 1 }} />
                Support
            </Button>

            {/* Modal for HubSpot Form */}
            <Modal
                show={formVisible}
                onHide={() => setFormVisible(false)} // Hide modal
                centered
                size="md"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Support Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="hubspot-form-container" style={{}}></div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default HubspotSupportWidget;